import moment from "moment";

moment.locale(window.appLocale);

export const getDates = (startDate, daysToAdd) => {
    var aryDates = [];

    for (var i = 0; i <= daysToAdd; i++) {
        var currentDate = new Date();
        currentDate.setDate(startDate.getDate() + i);

        var momentDate = moment(currentDate);
        aryDates.push({
            dayWeek: momentDate.format('ddd'),
            dayOfWeek: momentDate.format('d'),
            dayMonth: currentDate.getDate(),
            date: momentDate.format()
        });
    }

    return aryDates;
};

const DayAsString = dayIndex => {
    var weekdays = new Array(7);
    weekdays[0] = "Sun";
    weekdays[1] = "Mon";
    weekdays[2] = "Tue";
    weekdays[3] = "Wed";
    weekdays[4] = "Thu";
    weekdays[5] = "Fri";
    weekdays[6] = "Sat";

    return weekdays[dayIndex];
};

const MonthAsString = monthIndex => {
    var d = new Date();
    var month = new Array();
    month[0] = "January";
    month[1] = "February";
    month[2] = "March";
    month[3] = "April";
    month[4] = "May";
    month[5] = "June";
    month[6] = "July";
    month[7] = "August";
    month[8] = "September";
    month[9] = "October";
    month[10] = "November";
    month[11] = "December";

    return month[monthIndex];
};
